export default {

  formatCardTitle(subject, allSectionsDatas, titreActuel) {
    // on construit le titre du sujet
    let cardTitle = ''
    // si il y a une heure de diffusion dans les 4 premiers caractères du titreActuel on la garde
    let titreFirstChars = titreActuel.substr(0, 5)
    if ( titreFirstChars.search(/\d\dh\d\d/i) !== -1 ){
      cardTitle = titreFirstChars + ' '
    }
    // format et nom
    if (null !== subject['format'] && subject['format'] !== '') {
      cardTitle += '#' + allSectionsDatas.format.datas.name + ' '
    }
    cardTitle += subject['title']
    if (null !== subject['lieu'] && subject['lieu'] !== '') {
      cardTitle += ' - ' + allSectionsDatas.lieu.datas
    }
    // les dates à afficher
    let options = {month: 'numeric', day: 'numeric'} // les options pour l'affichage le format d'affichage des dates
    let dateStart = '', dateEnd = '', dateStartPrefix = '', dateEndPrefix = ' '
    if (null !== subject['validiteStart'] && subject['validiteStart'] !== '') {
      let date = new Date(allSectionsDatas.validiteStart.datas)
      dateStart = date.toLocaleDateString('fr-FR', options)
    } else {
      // si pas de date de début la date de fin est préfixée
      dateEndPrefix = 'fin: '
    }
    if (null !== subject['validiteEnd'] && subject['validiteEnd'] !== '') {
      let date = new Date(allSectionsDatas.validiteEnd.datas)
      dateEnd = date.toLocaleDateString('fr-FR', options)
    } else {
      // si pas de date de fin mais une date de début on la préfixe
      if (dateStart !== '') {
        dateStartPrefix = 'deb: '
      }
      //  et en tout cas pas de préfixe sur la date de fin
      dateEndPrefix = ''
    }
    // la chaine de la date, on l'ajoute si il y a du contenu
    let chaineDate = dateStartPrefix + dateStart + dateEndPrefix + dateEnd
    if (chaineDate !== '') {
      cardTitle += ' - ' + chaineDate
    }
    // on retourne le titre complet
    return cardTitle
  },

  formatCardDescription(subject, allSectionsDatas) {
    let descSections = ''
    // on construit la description
    // TODO on utilise ici les object du sujet mais il faudrait pouvoir afficher les titres plus proprement dans Trello
    let elemsDescription = ['resume', 'intervenants', 'infosAnimateur', 'infosRealisateur', 'titreAPasser', 'titlePodcast', 'descriptionPodcast', 'tagPrincipal', 'tagSecondaire',  'image', 'dateDiffusion', 'audio']
    for (let i = 0; i < elemsDescription.length; i++) {
      // la description fournie dans le sujet pour cette section
      let descript = subject[elemsDescription[i]]
      // si il existe une description spécifique à Trello on l'utilise à la place
      if (undefined !== allSectionsDatas[elemsDescription[i]].trelloDatas) {
        descript = allSectionsDatas[elemsDescription[i]].trelloDatas
      }
      // si à ce moment la description est définie on ajoute la section dans la description globale de la carte
      if (descript !== '' && descript !== null && descript !== undefined) {
        descSections += '### ' + elemsDescription[i] + ' \x0A \x0A  ' + descript + ' \x0A \x0A --- \x0A'
      }
    }
    // on ajoute les URL mixcloud et wordpress si elles existent
    if ( subject.mixcloudURL !== null && subject.mixcloudURL !== undefined && subject.mixcloudURL !== ''){
      descSections += '### URL Mixcloud : \x0A \x0A ' + subject.mixcloudURL +  ' \x0A \x0A --- \x0A'
    }
    if ( subject.wordpressURL !== null && subject.wordpressURL !== undefined && subject.wordpressURL !== ''){
      descSections += '### URL Wordpress : \x0A \x0A ' + subject.wordpressURL +  ' \x0A \x0A --- \x0A'
    }
    return descSections
  }

}



// WEBPACK FOOTER //
// ./src/utils/utils.js